module.exports = __webpack_public_path__ + "img/ears-01.d525af75.svg";